import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { useParams } from 'react-router-dom';
import { useGetAnnouncementDetailsQuery } from '@/redux/announcements';
import { AnnouncementOverviewDetailsPanel } from '@/views';

const useId = () => {
  const params = useParams<'id'>();
  return params.id!;
};

export function AnnouncementOverviewDetailsPage() {
  const { t } = useTranslation();
  const id = useId();

  const { data } = useGetAnnouncementDetailsQuery({ id });
  const title = data?.title ?? t('fetchFallbackTitle');

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/announcements">
          {t('announcements.overview.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="announcement" />}
          color="#814A93"
        >
          <AnnouncementOverviewDetailsPanel id={id} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
